var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 46.13 40.599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4739",
    "data-name": "Path 4739",
    d: "M569.2,799.162h24.241a1.337,1.337,0,0,0,1.285-.969l5.346-18.713a1.337,1.337,0,0,0-1.285-1.7h-32.67l-.955-4.3a1.337,1.337,0,0,0-1.305-1.047h-8.02a1.337,1.337,0,0,0,0,2.673h6.948l4.826,21.717a4.009,4.009,0,0,0,1.593,7.689h24.237a1.337,1.337,0,0,0,0-2.673H569.208a1.336,1.336,0,0,1,0-2.673Zm27.815-18.713-4.583,16.039H570.28l-3.564-16.039Z",
    transform: "translate(-554.505 -772.429)",
    fill: "#707070",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4740",
    "data-name": "Path 4740",
    d: "M612.028,914.5a4.01,4.01,0,1,0,4.01-4.01A4.015,4.015,0,0,0,612.028,914.5Zm4.01-1.336A1.337,1.337,0,1,1,614.7,914.5,1.338,1.338,0,0,1,616.038,913.159Z",
    transform: "translate(-598.662 -878.407)",
    fill: "#707070",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4741",
    "data-name": "Path 4741",
    d: "M693.328,914.5a4.01,4.01,0,1,0,4.01-4.01A4.015,4.015,0,0,0,693.328,914.5Zm4.01-1.336A1.337,1.337,0,1,1,696,914.5,1.338,1.338,0,0,1,697.338,913.159Z",
    transform: "translate(-661.071 -878.407)",
    fill: "#707070",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.da46c7dbcf70c7772f53521e6042af76.svg";
export { ForwardRef as ReactComponent };